import HardwareSerializer from 'eflex/serializers/hardware';

export default class KeyenceSerializer extends HardwareSerializer {}
